<div id="ex-wrap" class="exchange-wrapper" #exchangeWrapper
  [ngClass]="{'keyboard-showing': isKeyboardDoneShowing, 'high-pad': currentConversation.length > 0}">
  <div class="exchange" *ngFor="let exchange of currentConversation; let isLast = last; let i = index;">

    <div class="exchange-info left" *ngIf="(exchange.agent || currentDataModel) && !appState.agent.isSearchingFlights()">
      <div class="exchange-avatar" *ngIf="exchange.agent">
        <app-svg-loader height="32px" url="assets/logos/tail-one-logo-chip-gradient-black.svg"></app-svg-loader>
      </div>
      <div class="exchange-text">
        {{agentTypedText}}
      </div>
    </div>

    <div class="typing-wrapper" *ngIf="appState.agent.isHandlingQuery() || appState.agent.isSearchingFlights()">
      <app-ai-typing></app-ai-typing>
    </div>

    <div *ngIf="currentDataModel && !appState.device.isKeyboardFocused()">
      <app-agent-data-card-inline id="card" [currentDataModel]="currentDataModel"></app-agent-data-card-inline>
    </div>

    <div class="actions-wrapper" *ngIf="isLast && exchange.agent">
      <app-primary-btn *ngIf="hasMatches" (click)="onClickViewOptions()" mt="8px" mb="16px" animated="true"
        [gradient]="true">
        View Available Options
      </app-primary-btn>
      <app-primary-btn *ngIf="appState.agent.isNoResult()" (click)="onClickSetupAgent()" mt="8px" mb="16px"
        [gradient]="true">
        Watch for Flights
      </app-primary-btn>
      <div class="keep-typing-wrapper" (click)="onClickMakeChanges()" *ngIf="hasMatches || appState.agent.isNoResult()">
        <div class="text">Make Changes</div>
      </div>
    </div>

  </div>

</div>


<app-agent-setup-watcher *ngIf="showAssignToAgent" (onClose)="onClickCancelAssign()"
  [flightData]="appState.agent.currentDataModel()"></app-agent-setup-watcher>